module.exports = __webpack_public_path__ + "static/media/30.77c62f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/30.png
// module id = 1380
// module chunks = 0